export default __webpack_public_path__ + "static/media/hhn123.880801dc.png";